export const common = {
  nav: {
    home: 'ホーム',
    about: '施設について',
    rooms: '客室・空間',
    gallery: 'ギャラリー',
    reservation: '予約する',
    access: 'アクセス',
    contact: 'お問い合わせ',
    forOwners: 'For Property Owners',
    freeConsultation: '無料相談',
  },
  hero: {
    title: '伝統と現代が織りなす',
    subtitle: '特別な滞在体験',
    description: '東京・大田区馬込に佇む、歴史ある古民家を一棟貸し。日本の伝統美と現代の快適さが調和した、忘れられないひとときをお過ごしください。',
    bookNow: '今すぐ予約',
    viewGallery: 'ギャラリーを見る',
  },
  about: {
    title: '施設について',
    subtitle: '伝統的な日本建築の美しさと、現代的な快適さの融合',
    description: '馬込古民家は、東京都大田区の閑静な住宅街に位置する、築年数を重ねた伝統的な日本家屋です。丁寧に改修され、現代の快適さを保ちながら、日本の伝統的な美意識と建築様式を体験できる特別な空間となっています。',
    feature1Title: '一棟貸し',
    feature1Desc: 'プライベートな空間で、ご家族やご友人とゆったりとお過ごしいただけます',
    feature2Title: 'フルキッチン完備',
    feature2Desc: '本格的な調理が可能なキッチンで、お好みの料理をお楽しみください',
    feature3Title: '最大8名収容',
    feature3Desc: '広々とした空間で、グループでの滞在も快適にお過ごしいただけます',
    feature4Title: '伝統的な和室',
    feature4Desc: '畳の香りと木の温もりに包まれた、本格的な和の空間',
  },
  rooms: {
    title: '客室',
    subtitle: '伝統的な和の空間で、心安らぐひとときを',
    room1: '間取り図',
    room2: 'フルキッチン',
    room3: '簡易ベッド',
    capacity: '最大収容人数',
    guests: '8名様',
    amenities: '設備・アメニティ',
    amenitiesList: 'フルキッチン、冷蔵庫、電子レンジ、調理器具、食器、Wi-Fi、エアコン、暖房、洗濯機、バスルーム、トイレ、タオル、アメニティ',
  },
  gallery: {
    title: 'ギャラリー',
    subtitle: '写真で感じる、馬込古民家の魅力',
  },
  reservation: {
    title: 'ご予約',
    subtitle: '特別な滞在をご予約ください',
    name: 'お名前',
    email: 'メールアドレス',
    phone: '電話番号',
    checkin: 'チェックイン',
    checkout: 'チェックアウト',
    guests: '宿泊人数',
    purpose: '滞在目的',
    purposePlaceholder: '滞在目的を選択',
    purposeOptions: {
      tourism: '観光・旅行',
      workation: 'ワーケーション・リモートワーク',
      longStay: '長期滞在（7泊以上）',
      business: '出張',
      other: 'その他',
    },
    message: 'ご要望・メッセージ',
    submit: '予約リクエストを送信',
    submitting: '送信中...',
    success: 'ご予約リクエストを受け付けました。担当者より折り返しご連絡いたします。',
    error: '送信に失敗しました。もう一度お試しください。',
    bookingPlatforms: '予約サイトからもご予約いただけます',
    bookOnAirbnb: 'Airbnbで空き状況を確認・予約',
    bookOnJalan: 'じゃらんで空き状況を確認・予約',
    orDirectBooking: 'または直接お問い合わせ',
    directBookingTitle: '直接予約のメリット',
    directBookingBenefit1: '最安値保証 — プラットフォーム手数料なし',
    directBookingBenefit2: 'チェックイン・アウト時間の柔軟対応',
    directBookingBenefit3: 'ホストと直接コミュニケーション',
    directBookingBenefit4: '長期滞在の特別割引あり',
    required: '必須',
    guestsPlaceholder: '― 人数を選択 ―',
    guestSingular: '名様',
    guestPlural: '名様',
    messagePlaceholder: 'ご要望・ご質問などお気軽にどうぞ（500文字以内）',
    confirmNote: '※ 予約リクエスト確認後、担当者よりご連絡いたします。',
  },
  contact: {
    title: 'お問い合わせ',
    subtitle: 'ご質問やご相談がございましたら、お気軽にお問い合わせください',
    name: 'お名前',
    email: 'メールアドレス',
    subject: '件名',
    message: 'メッセージ',
    submit: '送信',
    submitting: '送信中...',
    success: 'お問い合わせを受け付けました。担当者より折り返しご連絡いたします。',
    error: '送信に失敗しました。もう一度お試しください。',
    address: '住所',
    addressDetail: '〒143-0022 東京都大田区東馬込1-12-12',
    access: 'アクセス',
    accessDetail: '都営浅草線「馬込駅」より徒歩8分',
    faqBannerTitle: '送信前に、よくある質問をご確認ください',
    faqBannerDesc: '料金・手続き・運営管理に関するよくある質問にすでに回答しています。',
    faqBannerBtn: 'FAQを見る',
    accessInfoTitle: 'アクセス情報',
    sendMessageTitle: 'メッセージを送る',
    inquiryType: 'お問い合わせ種別',
    inquiryTypePlaceholder: 'お問い合わせ種別を選択',
    inquiryOptions: {
      minpaku: '民泊登録・許可申請',
      ryokan: '旅館業ライセンス取得',
      management: '物件管理・運営代行',
      pricing: '料金・プラン',
      marketing: 'Airbnbリスティング・集客',
      revenue: '収益シミュレーション',
      other: 'その他',
    },
    messagePlaceholder: 'お問い合わせ内容をご記入ください（500文字以内）',
    detailLabel: 'ご相談内容',
    detailPlaceholder: '物件の場所・現在の状況・ご希望など、詳しくご記入ください（500文字以内）',
  },
  access: {
    label: 'アクセス',
    title: 'アクセス・地図',
    subtitle: '東京都大田区東馬込に位置する、閑静な住宅街の古民家です',
    addressLabel: '住所',
    addressLine1: '東京都大田区東馬込1-12-12',
    addressLine2: '〒143-0022 東京都大田区東馬込1-12-12',
    trainLabel: '電車でのアクセス',
    trainLine1: '都営浅草線「馬込駅」より徒歩約3分',
    trainLine2: '',
    busLabel: 'バスでのアクセス',
    busLine1: '都バス「馬込駅前」バス停より徒歩約2分',
    busLine2: '',
    parkingLabel: '駐車場',
    parkingLine1: '近隣にコインパーキングあり',
    parkingLine2: 'お車でお越しの際はご相談ください',
    phoneLabel: '電話番号',
    phoneNumber: 'お問い合わせください',
    phoneHours: '月〜金 9:00〜18:00（JST）',
    emailLabel: 'メールアドレス',
    emailAddress: 'info@magomekominka.com',
    emailNote: '2営業日以内にご返信いたします',
    openMap: 'Google マップで開く',
  },
  footer: {
    description: '東京・大田区馬込に佇む、伝統的な古民家一棟貸し宿泊施設。日本の美しさと現代の快適さが調和した、特別な滞在体験をお届けします。',
    quickLinks: 'クイックリンク',
    followUs: 'フォローする',
    rights: 'All rights reserved.',
    napTitle: '横田税務会計事務所',
    napAddress: '東京都大田区東馬込1-12-12',
    napAddressEn: '1-12-12 Higashi-Magome, Ota City, Tokyo',
    napPhone: '電話番号：お問い合わせください',
    napServiceArea: 'サービスエリア：大田区・東京都全域',
    napAccess: '都営浅草線「馬込駅」徒歩圏内',
  },
  stickyButton: {
    title: '無料30分',
    subtitle: '相談',
  },
  ownersBanner: {
    subtitle: '東京でAirbnbをお考えのオーナー様へ',
    linkText: 'オーナー様向けサポートサービスについて詳しく見る →',
  },
  airbnbLead: {
    title: '東京でAirbnbを始めたいとお考えですか？',
    description: '民泊登録・旅館業ライセンス取得から物件管理まで、ワンストップでサポートします。大田区を拠点に、実際の運営経験をもとにした実践的なアドバイスを提供します。',
    ctaButton: '無料相談を申し込む',
    badge1: '無料・無義務の相談',
    badge2: '実際の運営経験あり',
    badge3: '許可申請から管理まで完全サポート',
  },
  trust: {
    badge: '選ばれる理由',
    title: '東京の物件オーナーに信頼されています',
    subtitle: '実際の運営経験と包括的なサポートで、あなたの成功をお手伝いします。',
    point1Title: '実際のAirbnb運営経験',
    point1Description: '大田区で自社の古民家を実際に運営しています。理論ではなく、実体験に基づいたアドバイスを提供します。',
    point2Title: '許可申請の完全サポート',
    point2Description: '民泊登録から旅館業ライセンス取得まで、書類作成から行政対応まで一括してお任せいただけます。',
    point3Title: '収益最大化の戦略',
    point3Description: '東京の実際の市場データに基づいた価格戦略。平均30%以上の収益向上実績があります。',
    point4Title: '24時間ゲスト対応',
    point4Description: '多言語対応の24時間ゲストサポートで、オーナー様は収益に集中できます。',
    point5Title: '透明性の高い報告',
    point5Description: '月次収益レポートと明確な料金体系。隠れたコストや驚きはありません。',
    ctaButton: 'サービス詳細を見る',
  },
  howItWorks: {
    title: 'ご利用の流れ',
    subtitle: '相談から開業まで、シンプルで透明なプロセス',
    step1Number: '01',
    step1Title: '無料相談',
    step1Desc: '物件の詳細や目標をお聞かせください。許可申請、収益見込み、次のステップについて誠実にアドバイスします。',
    step2Number: '02',
    step2Title: '物件調査・プラン作成',
    step2Desc: '物件の適性を評価し、必要な要件を確認した上で、カスタマイズされたアクションプランを作成します。',
    step3Number: '03',
    step3Title: '開業・継続サポート',
    step3Desc: '許可申請からゲスト管理まで、すべてお任せください。オーナー様は収益に集中できます。',
    ctaButton: '無料相談を予約する',
    ctaNote: '30分 • 無義務 • 明確なロードマップ',
  },
  urgency: {
    title: '東京でAirbnbを始めたいとお考えですか？',
    description: '許可申請のルールは複雑で、ミスがあると開業が遅れることも。意思決定の前に、明確で実践的なアドバイスを受けましょう。',
    ctaButton: '無料相談を予約する',
    note: '30分相談 • 無義務 • 実際の運営経験に基づく',
  },
  trustRisk: {
    title: 'プレッシャーなしの無料相談',
    description: '実際の運営経験に基づいた実践的なアドバイスを提供します。進めないと決めた場合でも、明確なロードマップをお渡しします。',
    badge1Title: '無義務',
    badge1Desc: 'プレッシャーなしの無料アドバイス',
    badge2Title: '実際の経験',
    badge2Desc: '自社物件を運営しています',
    badge3Title: '明確なロードマップ',
    badge3Desc: 'すぐに使える実践的なガイダンス',
    whatYouGetTitle: '無料相談でわかること',
    item1: '物件のポテンシャルについての正直な評価',
    item2: '許可申請の要件とスケジュールの明確な説明',
    item3: 'あなたの物件の立地に基づいた現実的な収益予測',
    item4: '自分でも実行できるステップバイステップのロードマップ',
    ctaButton: '無料相談を予約する',
    ctaNote: '月〜金 9:00〜18:00（JST）対応',
  },
  faq: {
    title: 'よくある質問',
    subtitle: '東京でのAirbnb・民泊ビジネスの開始・運営に関するよくある質問',
    ctaText: 'その他のご質問はお気軽にどうぞ。',
    ctaButton: '無料相談を予約する',
    q1: '東京でAirbnbを始めるにはどうすればいいですか？',
    a1: '東京でAirbnbを始めるには、適切なライセンスの取得が必要です。主に2つの選択肢があります：民泊（住宅宿泊事業）登録と旅館業（簡易宿所）ライセンスです。民泊は年間180日まで営業可能で、地方自治体への届出が必要です。旅館業ライセンスは年間を通じた営業が可能ですが、より厳しい施設基準や消防設備の要件を満たす必要があります。',
    q2: '民泊と旅館業ライセンスの違いは何ですか？',
    a2: '民泊（住宅宿泊事業）は、物件オーナーが年間180日まで自宅を貸し出せる登録制度です。要件はシンプルですが、営業日数に制限があります。旅館業（簡易宿所）は、日数制限なく年間を通じた営業が可能なライセンスです。ただし、より厳しい施設基準、消防設備、定期検査が必要です。',
    q3: '外国人でも日本でAirbnbを始められますか？',
    a3: 'はい、外国人でも日本でAirbnbビジネスを始めることができますが、重要な要件があります。日本でビジネス活動を許可する適切な在留資格が必要です。物件の所有権または有効な賃貸契約が必要で、問題発生時に30分以内に対応できる日本在住の管理者を指定する必要があります。',
    q4: '東京での民泊登録にはどのくらい時間がかかりますか？',
    a4: '東京での民泊登録は、準備開始から承認まで通常2〜4ヶ月かかります。内訳は：物件調査・準備（2〜3週間）、書類作成・消防設備検査（2〜4週間）、自治体への申請（1〜2週間の審査）、最終承認・登録（1〜2週間）です。',
    q5: '開始にはどのくらいの費用がかかりますか？',
    a5: '費用はサービスの範囲や物件の状態によって異なります。民泊登録の申請サポート、書類作成、現地調査を含むプランをご用意しています。物件管理サービスについては、収益に応じた成果報酬型の料金体系を採用しているため、初期費用を抑えてスタートできます。',
    q6: '自己管理が難しい場合、どこまで対応してもらえますか？',
    a6: '予約管理、ゲスト対応、清掃手配、鍵の受け渡し、トラブル対応、月次収益レポートまで、すべてお任せいただけます。オーナー様はほぼ手放しでAirbnb運営が可能です。',
    q7: 'マンションでもAirbnbはできますか？',
    a7: 'マンションでのAirbnbは、建物の管理規約で禁止されていない限り可能です。まず管理規約を確認し、宿泊や短期賃貸を禁止する条項がないかを確認する必要があります。明示的な禁止がない場合、または承認が得られる場合は申請が可能です。',
    q8: '近隣からのクレームが心配です。どのように対応していますか？',
    a8: 'ゲストに対して明確なハウスルール（騒音、ゴミ出し、共用部の使用など）を設定し、チェックイン時に丁寧に説明することで問題を未然に防ぎます。クレームが発生した場合は、24時間対応体制で迅速に状況を把握し対処します。',
    q9: 'どのくらいの収益が見込めますか？',
    a9: '収益は物件の立地、広さ、設備、稼働率によって大きく異なります。東京の人気エリア（浅草、新宿、渋谷周辺など）では、1LDK〜2LDKの物件で月収20万〜50万円になるケースもあります。過去の運営データをもとに、無料の収益シミュレーションを提供しています。',
    q10: '相談だけでも大丈夫ですか？契約を迫られませんか？',
    a10: 'もちろん、相談だけでも大歓迎です。無料相談では、現在の状況やご質問を丁寧にお聞きし、最適な選択肢をご提案することを最優先にしています。その場で契約を迫ることは一切ありません。ご自身のペースでご判断ください。',
  },
  seo: {
    home: {
      title: '馬込古民家 | 東京・大田区の古民家一棟貸し＆Airbnb運営代行',
      description: '東京・大田区馬込の伝統的な古民家を一棟貸し。最大8名収容、フルキッチン完備。民泊登録・旅館業ライセンス取得から運営代行まで、現役ホストが実務ベースでサポートします。',
      keywords: '馬込古民家, 東京民泊, 大田区Airbnb, 古民家一棟貸し, 民泊登録サポート',
    },
    management: {
      title: 'Airbnb運営代行サービス東京 | 大田区・東京全域対応',
      description: '東京のAirbnb運営代行サービス。ゲスト対応・ダイナミックプライシング・清掃手配・月次レポートまで完全代行。大田区を拠点に東京全域の物件オーナー様をサポートします。',
      keywords: 'Airbnb運営代行 東京, 民泊管理 大田区, 短期賃貸管理 東京, ゲスト対応代行',
    },
    support: {
      title: '民泊・簡易宿所開業サポート東京 | 旅館業ライセンス申請代行',
      description: '東京の民泊・簡易宿所開業を現役ホストがサポート。旅館業ライセンス申請、民泊届出、保健所・消防対応から収益化まで実務経験に基づいた確実なサポートを提供します。',
      keywords: '民泊登録 東京, 旅館業ライセンス 申請, 簡易宿所開業, 民泊届出サポート',
    },
    forOwners: {
      title: '東京Airbnb運営代行＆民泊ライセンスサポート | 物件オーナー向け',
      description: '東京の物件オーナー向けAirbnb運営代行・民泊ライセンスサポート。ライセンス取得から日常運営・清掃まで、エンドツーエンドで完全サポート。初回相談無料。',
      keywords: '東京 Airbnb オーナー向け, 民泊ライセンス サポート, 物件管理 東京, 運営代行 大田区',
    },
    pricing: {
      title: 'Airbnb運営代行料金プラン東京 | 透明な料金体系',
      description: '東京のAirbnb運営代行・民泊サポートの料金プラン。開業サポート・フルセットアップ・運営代行・清掃パッケージを明確な料金でご提供。物件オーナー向け。',
      keywords: 'Airbnb運営代行 料金, 民泊サポート 費用, 東京 短期賃貸 プラン, 運営代行 価格',
    },
    minpakuRegistration: {
      title: '東京民泊登録ガイド | 旅館業ライセンス申請ステップ解説',
      description: '東京での民泊登録を徹底解説。旅館業ライセンス申請の全手順・必要書類・スケジュール・よくある失敗を大田区の実運営経験をもとに詳しく説明します。',
      keywords: '民泊登録 東京, 旅館業ライセンス 申請, 東京 Airbnb サポート, 大田区 短期賃貸',
    },
    guide: {
      title: '東京民泊開業ガイド2026 | ライセンス取得から収益化まで完全解説',
      description: '東京でAirbnbビジネスを始めるための完全ガイド。民泊と旅館業の違い、ライセンス取得手順、スケジュール、よくある失敗、収益シミュレーション、運営代行の選び方を解説。',
      keywords: '東京民泊ガイド, Airbnb 始め方 東京, 民泊 旅館業 違い, 民泊ライセンス 取得',
    },
    caseStudy: {
      title: '大田区民泊開業事例 | 東京Airbnb成功ケーススタディ',
      description: '大田区の物件オーナーが初回相談から3.5ヶ月で初予約を獲得した実際の事例。旅館業ライセンス取得、月収18万円以上、稼働率78%を達成した東京民泊サポートの実績。',
      keywords: '大田区 民泊 事例, 東京 Airbnb 成功事例, 旅館業ライセンス 大田区, 民泊サポート 実績',
    },
    adsLanding: {
      title: '東京でAirbnbを合法的に始める | 民泊・旅館業ライセンスサポート',
      description: '東京の民泊・旅館業ライセンス取得を専門家がサポート。大田区拠点の現役ホストによるエンドツーエンドのAirbnb運営代行。無料30分相談受付中。開業サポート30万円〜。',
      keywords: '東京 Airbnb 合法, 民泊ライセンス サポート, 旅館業 申請 東京, Airbnb 開業 大田区',
    },
    airbnbGuide: {
      title: '東京Airbnb合法ガイド | 民泊・旅館業ライセンス完全解説',
      description: '東京でAirbnbを合法的に始めるための完全ガイド。民泊登録・旅館業ライセンスの要件、費用、スケジュール、申請手順を大田区の実運営経験をもとに詳しく解説します。',
      keywords: 'Airbnb 東京 ライセンス, 民泊登録 東京, 旅館業ライセンス 東京, Airbnb 運営代行 東京, 大田区 短期賃貸',
    },
  },
  schema: {
    management: {
      offerDescription: '月間売上の15%〜20%',
      service1: '価格調整・ダイナミックプライシング',
      service2: 'ゲスト対応（多言語）',
      service3: 'レビュー管理',
      service4: '清掃・リネン手配',
      service5: '月次売上レポート',
      service6: '確定申告サポート制度あり',
    },
  },
  taxOffice: {
    badge: '税務会計事務所',
    sectionTitle: '横田税務会計事務所',
    sectionSubtitle: '東京都大田区東馬込の民泊・Airbnb税務サポート専門家',
    businessName: '横田税務会計事務所',
    businessNameEn: 'Yokota Tax & Accounting Office',
    addressLabel: '所在地',
    addressJa: '東京都大田区東馬込1-12-12',
    addressEn: '1-12-12 Higashi-Magome, Ota City, Tokyo, Japan',
    serviceAreaLabel: 'サービスエリア',
    serviceArea: '大田区・東京都全域',
    serviceAreaEn: 'Ota City and Greater Tokyo',
    accessLabel: 'アクセス',
    accessJa: '都営浅草線「馬込駅」徒歩圏内',
    accessEn: 'Toei Asakusa Line — Magome Station',
    openMapBtn: 'Google マップで開く',
    supportTitle: '民泊・Airbnb税務サポート',
    supportItems: [
      '確定申告サポート制度（申告代理ではありません）',
      '大田区民泊税務サポート',
      '東京都民泊・Airbnb税務相談',
      '民泊税務サポート東京・初回相談無料',
      'Airbnb税務相談東京・収益申告サポート',
    ],
    disclaimer: '※「確定申告サポート制度」は、申告書の準備とアドバイスを提供するものであり、税理士による申告代理ではありません。',
    officeImageAlt: '横田税務会計事務所 — 大田区東馬込の税務会計事務所',
    officeImageCaption: '横田税務会計事務所 — 東京都大田区東馬込',
    officeImageSubCaption: '大田区民泊税務サポート・Airbnb税務相談東京',
  },
  managementContact: {
    title: '無料相談フォーム',
    name: 'お名前',
    nameRequired: '必須',
    phone: '電話番号',
    email: 'メールアドレス',
    emailRequired: '必須',
    propertyType: '物件タイプ',
    propertyTypePlaceholder: '選択してください',
    propertyTypeOptions: {
      mansion1k: 'マンション（1K〜1LDK）',
      mansion2ldk: 'マンション（2LDK以上）',
      house: '一戸建て',
      kominka: '古民家・戸建て',
      taxConsult: '税務相談',
      other: 'その他',
    },
    consultContent: 'ご相談内容',
    consultContentRequired: '必須',
    consultContentCounter: '{{count}}/500文字',
    consultContentPlaceholder: '物件の場所・現在の状況・ご希望などをご記入ください（500文字以内）',
    submit: '無料相談を申し込む（完全無料）',
    submitting: '送信中...',
    success: 'お問い合わせありがとうございます。2営業日以内にご連絡させていただきます。',
    error: '送信に失敗しました。お手数ですが、もう一度お試しください。',
    beforeContact: 'お問い合わせ前に',
    infoItems: [
      '初回相談は完全無料です',
      '東京エリアを中心に対応',
      '2営業日以内にご返信',
      '個人情報は厳重に管理します',
    ],
    recommendTitle: 'こんな方はぜひご相談を',
    recommendItems: [
      '物件はあるが運営できない',
      '副業で民泊を始めたい',
      '現在の収益に満足していない',
      '清掃業者を探している',
      'Airbnbの使い方が分からない',
    ],
    confirmNote: 'ご予約確認後、担当者よりご連絡いたします',
  },
  sns: {
    badge: 'SNS',
    title: '最新情報をチェック',
    subtitle: 'Instagram・X・LINE・TikTok・YouTube・Facebookで日々の様子や最新情報を発信しています',
    copied: 'コピー済み',
    copy: 'コピー',
    instagram: {
      title: 'Instagram フィード',
      subtitle: '最新の投稿をご覧ください',
      follow: 'フォローする',
      viewMore: 'Instagramでもっと見る →',
    },
  },
  privateDriver: {
    badge: 'Partner Service',
    title: 'プライベートドライバー',
    titleEn: 'Private Driver Service',
    description: 'KOMINKAと提携した専属ドライバーが、空港送迎から観光まで丁寧にサポート。',
    descriptionHighlight: 'English-speaking drivers available.',
    featureTitle: 'サービスの特徴',
    features: [
      { title: 'English対応ドライバー', desc: 'English-speaking professional drivers for international guests.' },
      { title: '安心・安全', desc: '完全保険加入・プロドライバーによる安全な移動をお約束します。' },
      { title: '24時間対応', desc: '早朝フライトや深夜到着にも対応。事前予約で確実にお迎えします。' },
      { title: '大型荷物OK', desc: 'ファミリー向けの大型車両も手配可能。スーツケース複数でも安心。' },
      { title: 'カスタムルート', desc: '昭和レトロスポット巡りや撮影ロケ地への特別ルートもご相談ください。' },
    ],
    menuTitle: 'サービスメニュー / Service Menu',
    priceGuide: 'Price Guide',
    pricingTitle: '料金の目安 / Pricing Guide',
    pricingNote: 'すべて税込・目安料金です。詳細はお問い合わせください。',
    discountBadge: 'Exclusive Discount',
    discountTitle: '宿泊者限定',
    discountOff: '10% OFF',
    discountSuffix: '特別割引',
    discountNote: '予約フォームにてご宿泊の旨をお伝えください',
    discountBtn: '今すぐ予約する',
    ctaBadge: 'Exclusive for KOMINKA Guests',
    ctaTitle: '宿泊者限定・特別料金',
    ctaDesc: 'KOMINKAご宿泊のお客様は、プライベートドライバーを特別割引でご利用いただけます。',
    ctaBtn: 'ドライバーを予約する',
    officialPartner: 'Official Partner',
    officialPartnerJa: '提携サービス',
    services: [
      {
        title: 'Airport Transfer',
        subtitle: '空港送迎',
        desc: 'Haneda / Narita airport pickup & drop-off. Meet & greet service available.',
        price: 'From ¥8,000',
      },
      {
        title: 'Tokyo City Tour',
        subtitle: '東京観光ドライブ',
        desc: 'Explore Showa-era neighborhoods, temples, and hidden gems with a local driver.',
        price: 'From ¥15,000 / 3h',
      },
      {
        title: 'Long Stay Support',
        subtitle: '長期滞在サポート',
        desc: 'Weekly or monthly driver service for shopping, day trips, and errands.',
        price: 'From ¥40,000 / week',
      },
      {
        title: 'Photo Location Drive',
        subtitle: '撮影ロケ送迎',
        desc: 'Transport to iconic Showa-era spots, retro shotengai, and film locations.',
        price: 'From ¥12,000 / 2h',
      },
    ],
    pricing: [
      {
        title: '空港送迎',
        subtitle: 'Airport Transfer',
        rows: [
          { label: '羽田空港 ⇔ 馬込（片道）', price: '¥8,000〜' },
          { label: '成田空港 ⇔ 馬込（片道）', price: '¥14,000〜' },
          { label: '深夜・早朝割増（22:00〜6:00）', price: '+¥2,000' },
          { label: '大型荷物（スーツケース3個以上）', price: '+¥1,000' },
        ],
        note: '※ 乗車人数4名まで同一料金',
      },
      {
        title: '東京観光ツアー',
        subtitle: 'Tokyo City Tour',
        rows: [
          { label: '3時間コース', price: '¥15,000〜' },
          { label: '5時間コース', price: '¥22,000〜' },
          { label: '終日（8時間）コース', price: '¥35,000〜' },
          { label: '昭和レトロ特別ルート', price: '+¥3,000' },
        ],
        note: '※ ガイド料・駐車場代含む',
      },
      {
        title: '撮影ロケ送迎',
        subtitle: 'Photo Location Drive',
        rows: [
          { label: '2時間コース', price: '¥12,000〜' },
          { label: '4時間コース', price: '¥20,000〜' },
          { label: '撮影スポット案内オプション', price: '+¥2,000' },
          { label: '機材・大型荷物対応', price: '+¥1,500' },
        ],
        note: '※ 事前にルート相談可能',
      },
      {
        title: '長期滞在サポート',
        subtitle: 'Long Stay Support',
        rows: [
          { label: '週1回プラン（月4回）', price: '¥40,000〜' },
          { label: '週2回プラン（月8回）', price: '¥72,000〜' },
          { label: '都度利用（1回3時間）', price: '¥12,000〜' },
          { label: '買い物・病院送迎', price: '¥6,000〜/回' },
        ],
        note: '※ 月払いで10%割引適用',
      },
    ],
  },
};

export default common;